import React, { useMemo } from 'react';
import { Layout, Menu, theme } from 'antd';
import {
  DashboardOutlined,
  MessageOutlined,
  TeamOutlined,
  SettingOutlined,
  BarChartOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGlobalStore } from '@/stores';
import type { MenuProps } from 'antd';

const { Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

/**
 * 侧边栏组件
 */
const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { collapsed, toggleCollapsed } = useGlobalStore();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const menuItems: MenuItem[] = useMemo(
    () => [
      {
        key: '/',
        icon: <DashboardOutlined />,
        label: '数据概览',
      },
      {
        key: '/tenants',
        icon: <AppstoreOutlined />,
        label: '租户管理',
      },
      {
        key: '/sessions',
        icon: <MessageOutlined />,
        label: '会话管理',
      },
      {
        key: '/users',
        icon: <TeamOutlined />,
        label: '用户管理',
      },
      {
        key: '/statistics',
        icon: <BarChartOutlined />,
        label: '数据统计',
      },
      {
        key: '/settings',
        icon: <SettingOutlined />,
        label: '系统设置',
      },
    ],
    []
  );

  const selectedKey = useMemo(() => {
    const path = location.pathname;
    // 精确匹配优先
    const exact = menuItems.find((item) => item?.key === path);
    if (exact) return exact.key;
    // 前缀匹配（排除根路径 '/'，否则所有路径都会匹配）
    const prefix = menuItems.find((item) => item?.key !== '/' && item?.key && path.startsWith(item.key as string));
    return prefix?.key || '/';
  }, [location.pathname, menuItems]);

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      onCollapse={toggleCollapsed}
      style={{ background: colorBgContainer }}
    >
      <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <h3 style={{ margin: 0, color: '#1890ff' }}>{collapsed ? 'W' : 'WeCom AI'}</h3>
      </div>
      <Menu
        mode="inline"
        selectedKeys={[selectedKey as string]}
        items={menuItems}
        onClick={handleMenuClick}
      />
    </Sider>
  );
};

export default Sidebar;
